import { lazy, Suspense } from "react";
import { Navigate } from "react-router-dom";
import { useAdminRole } from "@/hooks/useAdminRole";

const LearningHub = lazy(() => import("@/pages/LearningHub"));

/** The old learning path is archived: admins can still open it, members go to Simulation → Learn. */
export default function LearnGate() {
  const { data: isAdmin, isLoading } = useAdminRole();
  if (isLoading) return null;
  if (!isAdmin) return <Navigate to="/simulation?view=learn" replace />;
  return <Suspense fallback={null}><LearningHub /></Suspense>;
}
